import { makeStyles } from '@material-ui/core/styles'
import ConfigAccordionBase from './ConfigAccordionBase'
import { Text } from '../../1elements'
import EditorList from '../RefrenceData/EditorList'
import ReferenceDataDropdown from '../RefrenceData/ReferenceDataDropdown'

const ReferenceDataAccordion = ({
  onEditMode,
  selectedReferenceType,
  setSelectedReferenceType,
  items,
  addItem,
  updateItem,
  deleteItem,
}) => {
  const classes = useStyles()

  return (
    <ConfigAccordionBase className={classes.root} label={'Reference Data'} onEditMode={onEditMode}>
      <div className={classes.dropdown}>
        <ReferenceDataDropdown
          selectedReferenceType={selectedReferenceType}
          setSelectedReferenceType={setSelectedReferenceType}
          onEditMode={onEditMode}
        />
      </div>
      <div className={classes.list}>
        <Text type={'h9'}>{selectedReferenceType}</Text>
        <EditorList
          items={items}
          onEditMode={onEditMode}
          addItem={addItem}
          updateItem={updateItem}
          deleteItem={deleteItem}
        />
      </div>
    </ConfigAccordionBase>
  )
}

export default ReferenceDataAccordion

const useStyles = makeStyles({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 20,
    maxWidth: '98%',
    '& > div > p': {
      marginBottom: 30,
    },
  },
  dropdown: {
    marginBottom: 20,
  },
  list: {
    maxHeight: 400,
    overflowY: 'auto',
  },
})
